<template>
<div class="modal fade" role="dialog" id="ModalHistorial">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Historial Interacción</h4>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-8 ">
                        <template v-if="buscando_detalle">
                            <h3 class="text-center"><i class="fal fa-info-circle"></i> Seleccione una interacción.</h3>
                            <!--                                            <div class="alert alert-warning">-->
                            <!--                                            </div>-->
                        </template>
                        <template v-else>
                            <div class="chat-discussion">
                                <div class="chat-message " v-for="mensaje in mensajes" :class="'conver '+ revisa_direccion(mensaje) ">
                                    <div class="messagee">
                                        <a class="message-author"> {{mensaje.emisor}} </a>
                                        <span class="message-date"> {{mensaje.fecha+' '+mensaje.hora}} </span>
                                        <span class="message-content">{{mensaje.mensaje}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="col-md-4">
                        <div class="ibox">
                            <div class="ibox-content interacciones-list">
                                <!--                                                <div class="slimScrollDiv" style="position: relative; overflow: hidden; width: auto; height: 200px;"><div class="scroll_content" style="overflow: hidden; width: auto; height: 200px;">-->
                                <div v-for="interaccion in interacciones">
                                    <div class="feed-activity-list">
                                        <div class="feed-element cursorPointer" @click.prevent="buscarDetalle(interaccion.id_inter_global)">
                                            <!--                                                    <div class="float-right m-l-md" >-->
                                            <!--                                                        <i class="fab fa-whatsapp"></i> <br>-->
                                            <!--                                                    </div>-->
                                            <div class="media-body">
                                                <div class="float-right">
                                                    <span class="label label-primary" v-if="mirando === interaccion.id_inter_global">Viendo</span> <br>
                                                    <i class="fad fa-spinner-third" v-if="cargando === true"></i>
                                                </div>
                                                <div class="m-l-xs">
                                                    <!---->
                                                    <!---->
                                                    <!---->
                                                    <i class="fal fa-address-book"></i>{{interaccion.emisor}} <br>
                                                    <i class="fal fa-question-circle"></i> {{interaccion.intencion}}<br>
                                                    <i class="fal fa-calendar-alt"></i> {{interaccion.fecha}}<br>
                                                    <i class="fal fa-clock"></i> {{interaccion.hora}}<br>
                                                </div>
                                                <div class="float-left">
                                                    <br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--                                                    <div class="slimScrollBar" style="background: rgb(0, 0, 0); width: 7px; position: absolute; top: 38px; opacity: 0.4; display: none; border-radius: 7px; z-index: 99; right: 1px; height: 90.0901px;"></div>-->
                            <!--                                                    <div class="slimScrollRail" style="width: 7px; height: 100%; position: absolute; top: 0px; display: none; border-radius: 7px; background: rgb(51, 51, 51); opacity: 0.2; z-index: 90; right: 1px;"></div>-->
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: function () {
        return {

            id_inter_global: null,
            mirando: null,
            cargando: false,
            buscando_detalle: true,
            numAgente: null,
            loading_transferir: false,
        }
    },
    computed: {
        ...mapGetters({
            interacciones: 'interacciones/getHistorial',
            mensajes: 'interacciones/getMensajes'
        }),
    },
    name: "HistorialModalComponent",
    methods: {
        show(data) {
            this.reset()
            this.id_inter_global = data
            $('#ModalHistorial').modal('show')
            this.buscaInteracciones()
            this.getNumAgente()
        },
        hide() {
            $('#ModalHistorial').modal('hide')
        },
        reset() {
            this.buscando_detalle = true
            this.mirando = null
            this.cargando = false

        },
        showAlert(data) {
            this.$swal(data.message);
        },
        buscaInteracciones() {
            this.$store.dispatch('interacciones/buscarInteracciones', {
                id_inter_global: this.id_inter_global,
                opcion: 'SUPERVISOR'
            })
        },
        revisa_direccion(mensaje) {
            if (mensaje.direccion_mensaje == "Entrada" && mensaje.emisor_interaccion != mensaje.emisor) {
                return "right"
            }

            if (mensaje.direccion_mensaje == "Salida" && mensaje.emisor_interaccion != mensaje.emisor) {
                return "right"
            }
        },
        buscarDetalle(inter_global) {
            console.log(this.cargando);
            this.mirando = inter_global;
            this.cargando = true;
            this.$store.dispatch('interacciones/getDetalleHistorial', {
                id_inter_global: inter_global
            }).then(response => {
                this.buscando_detalle = false
                this.cargando = false
            });
        },
        getNumAgente() {
            axios.get('/admin/getNumero').then(response => {
                console.log('getNumero', response.data)
                this.numAgente = response.data
                console.log('numAgente', this.numAgente)
            }).catch(error => {

            })
        }

    },
}
</script>
<style lang="css">
    .message {
        background-color: #00194e;
        border: 1px solid #e7eaec;
        text-align: left;
        display: block;
        padding: 10px 20px;
        position: relative;
        border-radius: 4px;
    }
</style>
